/*
 * Подсказка при наведении. Из макета: тёмная плашка 260 px, задержка 400 мс,
 * подпись «не единственный способ получить сведения».
 */

.wrap {
  position: relative;
  display: inline-flex;
  max-width: 100%;
}

.bubble {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  z-index: var(--z-popover);
  width: 260px;
  /* На телефоне 360 плашка в 260 px плюс отступы уже упирается в край экрана. */
  max-width: min(260px, calc(100vw - 2 * var(--space-4)));
  padding: 8px 10px;
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-regular);
  line-height: 1.4;
  color: var(--tooltip-fg);
  background: var(--tooltip-bg);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-pop);
  text-wrap: pretty;
}

/* Плашка у правого края экрана открывается влево, иначе уезжает за границу. */
.alignEnd {
  left: auto;
  right: 0;
}
